import { getRailsEnv } from '@opendoor/shared-fe/railsEnv';
import Cookies from 'js-cookie';

const odRailsEnv = getRailsEnv();

/** @returns {string} hostname used for Buyer API requests */
export const getHost = () => {
  if (odRailsEnv === 'production') {
    return `https://buy.opendoor.com`;
  } else if (Cookies.get('qa_env')) {
    return 'https://qa-buy.simplersell.com';
  }
  return `https://staging-buy.simplersell.com`;
};
